

exports.__esModule = true;
exports.$xoTopupFundingRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

require('pages/xo-sidepage-add-card/route');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTopupFundingRoute = exports.$xoTopupFundingRoute = _index.$Route.extend('$xoTopupFundingRoute', {
    path: 'topupFunding',
    directive: _directive2['default'],
    children: [{
        name: '$SidepageAddCardRoute',
        attributes: {
            token: 'token',
            callbacks: 'addCardCallbacks'
        }
    }]
});

exports['default'] = $xoTopupFundingRoute;

angular.value("$xoTopupFundingRoute", $xoTopupFundingRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/topup/topup-funding/route.js
// module id = ../node_modules/xo-wallet-components/src/topup/topup-funding/route.js
// module chunks = 0